import Link from 'next/link'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { Athlete } from '~/domain/Athlete'
import linkStyles from '~/components/Link/index.module.scss'
import styles from './index.module.scss'

interface NftAthleteMuseumProps {
  athlete: Athlete
}

export const NftAthleteMuseum: React.FC<NftAthleteMuseumProps> = ({ athlete }) => {
  if (!athlete.museumUrl) return null

  return (
    <div className={ styles['athlete'] }>
      <div className={ styles['athlete__container'] }>
        <div className={ styles['athlete__header'] }>
          <p className={ styles['athlete__subtitle'] }>
            Verified Athlete

            <FontAwesomeIcon
              className={ styles['athlete__icon'] }
              icon={ faCircleCheck }
            />
          </p>

          <p className={ styles['athlete__title'] }>
            { athlete.name }
          </p>

          <Link
            href={ athlete.museumUrl }
            target="_blank"
            className={ `${styles['athlete__link']} ${linkStyles['link']}` }
          >
            Visit Athlete&apos;s Museum { }

            <FontAwesomeIcon
              icon={ faArrowRight }
            />
          </Link>
        </div>

        <div className={ styles['athlete__banner'] }>
          <Link
            href={ athlete.museumUrl }
            target="_blank"
            className={ `${styles['athlete__link']} ${linkStyles['link']}` }
          >
            <img
              src="/museum-logo-white.svg"
              alt="Legend Museum logo"
              className={ styles['athlete__banner__logo'] }
            />
          </Link>
        </div>
      </div>
    </div>
  )
}
